export const isEmpty = <T>(value: T | undefined | null): boolean =>
  value === undefined ||
  value === null ||
  value === '' ||
  (Array.isArray(value) && value.length === 0);
